import qs from 'query-string';
import Cookies from 'js-cookie';

/**
 * Add UTM parameters to cookie with 15 minutes expire
 */
export function setSetUtmCookies() {
  const inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
  const params = qs.parse(window.location.search);
  const utmKeys = Object.keys(params).filter((value) => value.startsWith('utm_'));
  utmKeys.forEach((key) => {
    Cookies.set(key, params[key], { expires: inFifteenMinutes });
  });
}

export function getUtmCookies() {
  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .filter((value) => value.startsWith('utm_'));
}

export function getUtmCookiesKeyValue() {
  const cookies = getUtmCookies();
  const formattedCookies = [];

  if (cookies.length > 0) {
    cookies.forEach((cookie) => {
      const formattedCookie = cookie.split('=');

      if (formattedCookie.length === 2) {
        formattedCookies.push({key: formattedCookie[0], value: formattedCookie[1]});
      }
    })
  }

  return formattedCookies;
}

export function addUtmQueryString(href) {
  const utmQueryString = getUtmCookies().join('&');

  if (utmQueryString) {
    href += (href.split('?')[1] ? '&' : '?') + utmQueryString;
  }

  return href;
}
